export default __webpack_public_path__ + "static/img-hero-2022-cb71179ef07fc5cd9e15d797f1db6ed2.svg";